import {createApp} from 'vue'
import FormBooleanField from './FormBooleanField.options'

const el = '.kb-component--form-boolean-field'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FormBooleanFieldDOM) => {
            const props = {
                checked: FormBooleanFieldDOM.dataset.checked === 'true',
                elementId: FormBooleanFieldDOM.dataset.elementId
            }
            const component = createApp(FormBooleanField, props).use(Store)
            component.mount(FormBooleanFieldDOM)
        })
    }
}